import { useTranslation } from 'react-i18next';

function getHeaderText(stepNumber, isEditMode, translator) {
  switch (stepNumber) {
    case 1:
    case 2:
      return isEditMode
        ? translator('pages.createHearing.headerEdit')
        : translator('pages.createHearing.headerCreate');
    case 3:
      return translator('pages.createHearing.headerInvite');
    default:
      break;
  }
}

const CreateHearingHeader = ({ stepNumber, isEditMode }) => {
  const { t: translator } = useTranslation();

  return (
    <div>
      <div>
        <div className="create-hearing-header">
          <h2>{getHeaderText(stepNumber, isEditMode, translator)}</h2>
          <p>
            {translator('global.step')} {stepNumber} {translator('global.of')} 3
          </p>
        </div>
        <hr className="create-hearing-header-hr-top" />
      </div>
    </div>
  );
};

export { CreateHearingHeader };
